import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DefaultButton } from '@fluentui/react';
import styles from './AppShell.module.css';

interface AppShellProps {
  children: React.ReactNode;
  onLogout: () => void;
  themeMode: 'light' | 'dark';
  onToggleTheme: () => void;
}

export const AppShell: React.FC<AppShellProps> = ({
  children,
  onLogout,
  themeMode,
  onToggleTheme,
}) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      localStorage.removeItem('adminAccessToken');
      onLogout();
      navigate('/');
    } catch (error) {
      console.error('Logout failed');
      localStorage.removeItem('adminAccessToken');
      onLogout();
    }
  };

  return (
    <div className={styles.appShell}>
      <header className={styles.header}>
        <div className={styles.brand}>
          <h1>
            <strong>ResidentHood</strong>
            <sup>&reg;</sup> Site Manager
          </h1>
        </div>
        <nav className={styles.nav}>
          <button
            type="button"
            className={styles.navLink}
            onClick={() => navigate('/portfolios')}
          >
            Portfolios
          </button>
          <button
            type="button"
            className={styles.navLink}
            onClick={() => navigate('/tenants')}
          >
            Tenants
          </button>
          <DefaultButton
            text={themeMode === 'dark' ? 'Light' : 'Dark'}
            iconProps={{ iconName: themeMode === 'dark' ? 'Sunny' : 'ClearNight' }}
            onClick={onToggleTheme}
            styles={{
              root: {
                padding: '8px 12px',
                border: '1px solid var(--border-color)',
                backgroundColor: 'transparent',
                color: 'var(--text-secondary)',
              },
              rootHovered: {
                backgroundColor: 'var(--hover-bg)',
                borderColor: 'var(--border-color)',
                color: 'var(--accent-color)',
              },
            }}
          />
          <DefaultButton
            text="Logout"
            iconProps={{ iconName: 'SignOut' }}
            onClick={handleLogout}
            styles={{
              root: {
                padding: '8px 16px',
                border: '1px solid var(--border-color)',
                backgroundColor: 'transparent',
                color: 'var(--text-secondary)',
              },
              rootHovered: {
                backgroundColor: 'var(--hover-bg)',
                borderColor: 'var(--border-color)',
                color: 'var(--accent-color)',
              },
            }}
          />
        </nav>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
};
